import { useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { ServiceFinanceDisclosureText } from './ServiceFinanceDisclosureText';
import { TurnsDisclosureText } from './TurnsDisclosureText';
import { FinturfDisclosureText } from './FinturfDisclosureText';
import { GreenSkyDisclosureText } from './GreenSkyDisclosureText';

interface DisclosureTextProps {
    onOpenNotice: (notice: 'ElectronicRecordsDisclosure' | 'GeneralApplicationDisclosure') => void;
    onDisclosureChange: (attested: boolean) => void;
    onApplicantSignatureChange?: (base64Signature: string | null) => void;
    onCoApplicantSignatureChange?: (base64Signature: string | null) => void;
}

export const DisclosureText = ({
    onOpenNotice,
    onDisclosureChange,
    onApplicantSignatureChange,
    onCoApplicantSignatureChange,
}: DisclosureTextProps) => {
    const { disclosureBlocks = [] } = useProviderConfig();

    return (
        <>
            {disclosureBlocks.map(block => {
                switch (block) {
                    case 'turns':
                        return <TurnsDisclosureText key="disclosure-turns" />;
                    case 'finturf':
                        return <FinturfDisclosureText key="disclosure-finturf" />;
                    case 'serviceFinance':
                        return (
                            <ServiceFinanceDisclosureText
                                key="disclosure-serviceFinance"
                                onOpenNotice={onOpenNotice}
                            />
                        );
                    case 'greenSky':
                        return (
                            <GreenSkyDisclosureText
                                key="disclosure-greenSky"
                                onDisclosureChange={onDisclosureChange}
                                onApplicantSignatureChange={onApplicantSignatureChange}
                                onCoApplicantSignatureChange={onCoApplicantSignatureChange}
                            />
                        );
                    default:
                        return null;
                }
            })}
        </>
    );
};
